module.exports = __webpack_public_path__ + "img/p__宁夏.b7152cc3.png";